// app/javascript/src/components/Scheduling/SettingToggle.tsx
import * as React from 'react'
import styled from 'styled-components'
import Panel from '../Panel/Panel'
import Switch from '../Form/Switch'
import { Style } from '../../styles'

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${Style.spacing.x2};
`

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Style.spacing.x0_5};

  label {
    margin-bottom: 0;
    font-size: 15px;
    font-weight: 500;
    color: #5886c4;
    text-transform: none;
    cursor: pointer;
  }

  p {
    color: #637381;
  }
`

const Content = styled.div`
  margin-top: ${Style.spacing.x2};
`

interface IProps {
  id: string
  title: string
  description?: React.ReactNode
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  children?: React.ReactNode
}

export default function SettingToggle({ id, title, description, checked, onCheckedChange, children }: IProps) {
  const onToggle = () => onCheckedChange(!checked)

  return (
    <Panel>
      <Header>
        <HeaderContent>
          <label onClick={onToggle}>{title}</label>
          {description && <p>{description}</p>}
        </HeaderContent>
        <Switch name={id} checked={checked} onClick={onToggle} />
      </Header>
      {checked && children && <Content>{children}</Content>}
    </Panel>
  )
}
